import { Link } from 'react-router-dom';
import { stats } from '@/mocks/reviews';

export default function CTASection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Text Content */}
        <div className="flex flex-col items-center text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-950">
            准备好开始你的韩漫之旅了吗？
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-4 max-w-lg">
            加入数百万读者，畅享优质韩国漫画免费在线阅读体验
          </p>
          <Link
            to="/category/fantasy-adventure"
            className="mt-8 px-10 py-4 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 inline-flex items-center gap-2 whitespace-nowrap"
          >
            立即开始阅读
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-4xl mx-auto">
          {stats.map((stat, index) => (
            <div key={index} className="flex flex-col items-center text-center p-5 rounded-lg bg-background-100 border border-background-200/60">
              <span className="font-heading text-2xl md:text-3xl font-black text-primary-500">{stat.value}</span>
              <span className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}